import { render, staticRenderFns } from "./ArticleRevisionsRow.vue?vue&type=template&id=b869ba10&scoped=true&"
import script from "./ArticleRevisionsRow.vue?vue&type=script&lang=js&"
export * from "./ArticleRevisionsRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b869ba10",
  null
  
)

export default component.exports